module.exports = __webpack_public_path__ + "static/img/section02-02@t.b96e4c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/omron-healthcare/section02-02@t.jpg
// module id = yVD6
// module chunks = 0